import React from "react";
import { useLocation } from 'react-router-dom';
import { Route, Switch, Router, Redirect} from "react-router-dom";
import { GlobalProvider } from "./contexts/GlobalState";
import { ToastProvider } from "react-toast-notifications";

//import { App, Deal, Flights, LastMinute } from "./components";
//import { Terms, Service, Contact } from "./static";
import App from "./App"
import Category from "./Category"
import URLShortner from "./components/URLShortner"
import Deal from "./components/Package/Package"
import Article from "./components/Article/Article"
import Post from "./components/Post/Post"
import Posts from "./components/Post/Posts"
import BookingForm from "./components/Post/Form"
//import Destination from "./components/Destination_old"
import Destination from "./components/Destination"
//import Destination2 from "./components/Destination"
// Original form (keep for rollback): import Reserve from "./components/Reservation/Form"
import Reserve from "./components/Reservation/FormWizard"
import Terms from "./components/Page/Terms"
import Privacy from "./components/Page/Privacy"
import Accessibility from "./components/Page/Accessibility"
//import Service from "./static/Service"
//import Contact from "./static/Contact"
//import NotFound from "./static/NotFound"
//import About from "./static/About"
//import Media from "./static/Media"
//import Faq from "./static/Faq"
import Promotion from "./components/Page/Promotion"
import Members from "./components/Page/Members"
import MemberTerms from "./components/Page/MemberTerms"
import MemberSignup from "./components/Page/MemberSignup";
import Newsletter from "./components/Page/Newsletter"
import {createBrowserHistory} from 'history'
//import Details from "./components/CreditCard/Details";
import Confirmation from "./components/PaymentConfirmation/Confirmation";
import Promotion199 from "./components/Homepage/Promotions/199"
import PromotionMax199 from "./components/Homepage/Promotions/Max199"
import PromotionMaxItaly from "./components/Homepage/Promotions/MaxItaly"
import CookieConsent from "./features/CookieConsent"
import NewWebsiteBanner from "./features/NewWebsiteBanner"

const history = createBrowserHistory()

// Switch between two destination page version based on the &v=2 parameter
/*const DestinationPages = (props) => {
  const { search } = useLocation();
  const Page = search.indexOf('v=2')>0?Destination2:Destination;
  return <Page {...props} />;
}*/

const Routes = () => {
    return (
      <Router history={history}>
      <GlobalProvider>
      <ToastProvider
          autoDismiss
          autoDismissTimeout={6000}
          placement="bottom-center"
        >
        <Switch>
          {/* Homepage */}
          <Route exact path="/" component={Category} />         
          <Route path="/s/" component={URLShortner} />
          <Route path="/search" component={Category} />
          <Route path="/best-deals" component={Category} />
          <Route path="/last-minute" component={Category} />
          <Route path="/one-week" component={Category} />
          <Route path="/weekends" component={Category} />
          <Route path="/hot-deals" component={Category} />
          <Route path="/waterparks" component={Category} />
          <Route path="/luxury" component={Category} />
          <Route path="/casino" component={Category} />
          <Route path="/spa" component={Category} />
          <Route path="/israeli" component={Category} />
          <Route path="/near-chabad" component={Category} />
          <Route path="/5-stars" component={Category} />
          <Route path="/summer-deals" component={Category} />
          <Route path="/spring-deals" component={Category} />
          <Route path="/holiday-season-deals" component={Category} />
          <Route path="/xmas-deals" component={Category} />
          <Route path="/winter-deals" component={Category} />
          <Route path="/passover" component={Category} />
          <Route path="/passover-vacation-deals" component={Category} />
          <Route path="/summer-family" component={Category} />
          <Route path="/summer-vacation" component={Category} />
          <Route path="/sukkot-vacation-deals" component={Category} />          
          <Route path='/all-inclusive-deals' component={Category} />
          <Route path='/early-birds' component={Category} />


          {/*  Deals  */}
          <Route path="/deal/:deal_id/book/:quote_id" component={Reserve} />
          <Route path="/deal/:id" component={Deal} />
          <Route path="/article/:id" component={Article} />
          
          <Route path="/vac/:id/book/" component={BookingForm} />
          <Route path="/vac/:id" component={Post} />
          <Route path="/vac" component={Posts} />
          <Route path="/process_payment/:uid" component={Confirmation} />

          {/*  Static  */}
          <Route exact path="/terms.html" component={Terms} />
          <Route exact path="/privacy.html" component={Privacy} />
          <Route exact path="/accessibility.html" component={Accessibility} />
          {/*
          <Route exact path="/contact.html" component={Contact} />
          <Route exact path="/about.html" component={About} />
          <Route exact path="/media.html" component={Media} />
          <Route exact path="/faq.html" component={Faq} />
           */}
          <Route exact path="/members/" component={Members} />        
          <Route exact path="/members/terms.html" component={MemberTerms} />
          <Route exact path="/members/signup/" component={MemberSignup} />
          <Route exact path="/members/signin/" component={MemberSignup} />
          <Route exact path="/promotion/:id" component={Promotion} />
          <Route exact path="/join/imaleclub2" component={Newsletter} />

          {/* PROMOTIONS */}
          <Route path="/promotions/199" component={Promotion199} />
          <Route path="/promotions/max199" component={PromotionMax199} />
          <Route path="/promotions/maxitaly" component={PromotionMaxItaly} />

          {/*  Redirects  */}
          <Route exact path="/" component={Category}><Redirect to="/best-deals/" /></Route>
          <Route exact path="/flight/:id" component={Category}><Redirect to="/" /></Route>
          <Route path="/vacations" component={Category}><Redirect from="/vacations" to="/" /></Route>
          <Route path="/holidays" component={Category}><Redirect from="/holidays" to="/" /></Route>
          <Route path="/families" component={Category}><Redirect from="/families" to="/" /></Route>
          <Route path="/contact.html" component={Category}><Redirect from="/contact.html" to="/article/contact" /></Route>
          <Route path="/media.html" component={Category}><Redirect from="/media.html" to="/article/media" /></Route>
          <Route path="/about.html" component={Category}><Redirect from="/about.html" to="/article/about" /></Route>
          <Route path="/faq.html" component={Category}><Redirect from="/faq.html" to="/article/faq" /></Route>


          {/* Destination Pages */}
          <Route path="/:destination_name/:month" component={Destination} />
          <Route path="/:destination_name" component={Destination} />

          {/*<Route render={({ staticContext }) => {
            if (staticContext) {
              staticContext.status = 301;
            }
            return <Redirect from="/whatsapp/join2" to="https://chat.whatsapp.com/FZ6WeUWhzc93r88j4k4FH5" />
          }}/>*/}
          </Switch>
          <CookieConsent />
          <NewWebsiteBanner />
        </ToastProvider>
      </GlobalProvider>
      </Router>
    )
  }
  
  export default Routes